import { render, staticRenderFns } from "./DataPreventivo.vue?vue&type=template&id=74f9b0da&"
import script from "./DataPreventivo.vue?vue&type=script&lang=js&"
export * from "./DataPreventivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports